const Care = () => import(/* webpackChunkName: "Care" */ "@/views/care/Care");
const CarePhone = () => import(/* webpackChunkName: "Care Phone" */ "@/views/care/CarePhone");

const careRoutes = [
  {
    path: "care",
    name: "Care",
    redirect: {
      name: "Care Phone"
    },
    component: Care,
    children: [
      {
        path: "phone",
        name: "Care Phone",
        component: CarePhone
      }
    ]
  }
];

export default careRoutes;